import React, { useEffect, useState } from 'react';
import { Field, useFormikContext } from 'formik';

import { FormErrorUI, FormLabelUI, AutoCompleteSelectUI, DatePickerUI, InputUI } from '../Interface';
import employeeAttendenceService from '../../service/employeeAttendence.service';
import { EmployeeAttendanceMode } from '../../config/employeeAttendance';
import useParam from '../../context/ParamContext';
import { getProjectOrderNumberName } from '../../utils/getProjectOrderNumberName';

const EmployeeAttendanceFields = ({
  viewField,
  selectedValues,
  selectedRow,
  autocompleteOptions,
  mode,
  autocompleteData,
  getTaskListByProjectId,
}) => {
  const { params } = useParam();
  const { values, validateField, setFieldValue, errors } = useFormikContext();

  useEffect(() => {
    getTaskListByProjectId(values.projectId);
  }, [values.projectId]);

  const showProjectInfo =
    mode === EmployeeAttendanceMode.MAIN || params.EMPLOYEE_ATTENDANCE_SHOW_PROJECT_FIELDS_ALL_MODES === 'Y';

  return (
    <div className="grid grid-cols-5 gap-x-4 gap-y-2 md:mx-4 mb-5">
      <div className="col-span-5 md:col-span-1">
        <Field
          type="date"
          name="date"
          component={DatePickerUI}
          value={values.date}
          fullWidth
          disabled={viewField}
          label={<FormLabelUI text="Dátum" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.date} />}
          onChange={(date) => {
            setFieldValue('date', date).then(() => {
              validateField('date');
            });
          }}
          InputLabelProps={{ shrink: values.date !== '' }}
        />
      </div>
      {params.SHOW_EMPLOYEE_ATTENDANCE_SIMPLETASK_FIELD === 'Y' && mode !== EmployeeAttendanceMode.PHONE && (
        <div className="col-span-5 md:col-span-2">
          <Field
            type="text"
            name="simpleTaskName"
            as={InputUI}
            disabled
            fullWidth
            label={<FormLabelUI text="Feladat" />}
            variant="standard"
            helperText={<FormErrorUI message={errors.simpleTaskName} />}
            InputLabelProps={{ shrink: values.simpleTaskName !== '' }}
          />
        </div>
      )}
      <div className="col-span-5 md:col-span-2">
        <Field
          type="autocomplete"
          name="projectId"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Projekt" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.projectId} />}
          onChange={(_e, newVal) => {
            const findedProject = autocompleteData?.project.find((item) => item.projectId === newVal?.value);

            if (findedProject) {
              setFieldValue('projectOrderNumber', findedProject.orderNumber || '');
              setFieldValue('projectCompanyLocationName', findedProject.companyLocation?.name || '');
            } else {
              setFieldValue('projectOrderNumber', '');
              setFieldValue('projectCompanyLocationName', '');
            }

            setFieldValue('projectId', newVal?.value ?? null).then(() => {
              validateField('projectId');
            });
          }}
          disabled={viewField || mode === EmployeeAttendanceMode.DIALOG || values.simpleTaskId}
          InputLabelProps={{ shrink: values.projectId !== '' }}
          selectedValue={values.projectId}
          selectedLabelValue={selectedValues?.project?.projectName}
          dataset={autocompleteOptions.project}
        />
      </div>
      {showProjectInfo && (
        <>
          <div className="col-span-5 md:col-span-1">
            <Field
              type="text"
              name="projectOrderNumber"
              as={InputUI}
              disabled
              fullWidth
              label={<FormLabelUI text={getProjectOrderNumberName(params)} />}
              variant="standard"
              helperText={<FormErrorUI message={errors.projectOrderNumber} />}
              InputLabelProps={{ shrink: values.projectOrderNumber !== '' }}
            />
          </div>

          {params.PROJECT_COMPANY_LOCATION_FIELD === 'Y' && (
            <div className="col-span-5 md:col-span-1">
              <Field
                type="text"
                name="projectCompanyLocationName"
                as={InputUI}
                disabled
                fullWidth
                label={<FormLabelUI text="Telephely" />}
                variant="standard"
                helperText={<FormErrorUI message={errors.projectCompanyLocationName} />}
                InputLabelProps={{ shrink: values.projectCompanyLocationName !== '' }}
              />
            </div>
          )}
        </>
      )}
      {mode === EmployeeAttendanceMode.MAIN && (
        <div className="col-span-5 md:col-span-1">
          <Field
            type="autocomplete"
            name="statusId"
            component={AutoCompleteSelectUI}
            fullWidth
            label={<FormLabelUI text="Státusz" />}
            variant="standard"
            helperText={<FormErrorUI message={errors.statusId} />}
            onChange={(_e, newVal) => {
              setFieldValue('statusId', newVal?.value ?? null).then(() => {
                validateField('statusId');
              });
            }}
            disabled={viewField && selectedRow.id.length === 0}
            InputLabelProps={{ shrink: values.statusId !== '' }}
            selectedValue={values.statusId}
            selectedLabelValue={selectedValues?.status?.itemName}
            dataset={autocompleteOptions.status}
          />
        </div>
      )}
    </div>
  );
};

export default EmployeeAttendanceFields;
